<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-select v-model="query['storer.id']" :options="storers" clearable placeholder="placeholder.storer" @change="refresh"/>
        <vxe-input v-model="query['no']" clearable placeholder="placeholder.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['supplier.name']" clearable placeholder="placeholder.supplierName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.name']" clearable placeholder="placeholder.itemFilter" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-date-range-picker v-model="query.range" clearable linked-panels placeholder="business.label.invoiceTime" type="date" @change="refresh" @clear="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
        <vxe-button content="button.expConfirm" icon="vxe-icon-upload" status="info" @click="exp"/>
      </template>
      <vxe-table
        ref="table"
        :data="data"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow: true}"
        :column-config="{resizable: true}"
        :row-config="{isCurrent: true, isHover: true}"
        :loading="loading"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="order.invoiceTime" sortable title="business.label.invoiceTime" width="170"/>
        <vxe-column field="order.no" sortable title="business.label.orderNo" width="140"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:orderStatus}" field="order.orderStatus" title="business.label.orderStatus" width="100"/>
        <vxe-column field="storer.name" title="business.label.storerName" width="200"/>
        <vxe-column field="supplier.name" title="business.label.supplierName" width="400"/>
        <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.detail" icon="vxe-icon-association-form" status="primary" @click.stop="getDetail(row)"/>
            <vxe-button :disabled="row.order.orderStatus>=1" content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="getDetail(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'
import moment from 'moment'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'PurchaseOrderList',
  data() {
    return {
      loading: false,
      page: 1,
      size: 20,
      contentSize: 0,
      data: [],
      query: {
        'no': '',
        'storer.id': undefined,
        'supplier.name': '',
        'item.filter': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      },
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.8)
    }
  },
  created() {
    this.refresh()
  },
  props: {
    orderStatus: {
      type: Array,
      default: []
    },
    storers: {
      type: Array,
      default: []
    }
  },
  methods: {
    moment,
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.range.length !== 0) {
        args['dateFilter'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['dateFilter'] = null
      }
      findAll('purchaseOrderFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'no': '',
        'storer.id': undefined,
        'supplier.name': '',
        'item.filter': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
      this.refresh()
    },
    exp() {
      this.$refs.table.openExport()
    },
    add() {
      this.$emit('add')
    },
    getDetail(row) {
      this.$emit('getDetail', row)
    }
  }
}
</script>